import React from 'react';

const IconGoogleScholar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" role="img" fill="currentColor">
    <title>Google Scholar</title>
    <path d="M32 8L4 24l28 16 28-16L32 8zm0 4.2L52.5 22 32 33.8 11.5 22 32 12.2zM8 30v18l24 13.5L56 48V30L32 43.5 8 30z" />
  </svg>
);

export default IconGoogleScholar;
